import { render, staticRenderFns } from "./course_consultant_follow.vue?vue&type=template&id=70a25e22&scoped=true&"
import script from "./course_consultant_follow.vue?vue&type=script&lang=js&"
export * from "./course_consultant_follow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a25e22",
  null
  
)

export default component.exports